import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectCreationFailedAction = {
	type: 'SUBJECT_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectCreationFailedAction => ({
	type: 'SUBJECT_CREATION_FAILED',
	payload,
});
